import { CitiesI } from '../interfaces/cities.interface'
import { CitiesService } from '../services/cities.service'
import {
    CityPayloadT,
    CityResponseT,
    GetAllCitiesResponseT,
    GetCitiesBySenderResponseT,
    GetCityResponse,
    GetRegionsListResponseT,
    GetRegionsResponseT,
    GetZonesResponseT,
    RegionPayloadT,
    RegionResponseT,
    UpdateCityPayloadT,
} from '../types/cities.types'

const citiesService = new CitiesService()

class CitiesRealisation implements CitiesI {
    getAllList(
        page: number,
        search?: string,
        limit?: number,
        regionId?: number,
        statusId?: number,
        postCode?: string
    ): Promise<GetAllCitiesResponseT> {
        return citiesService.getAllList(page, search, limit, regionId, statusId, postCode)
    }

    getCity(city_id: number): Promise<GetCityResponse> {
        return citiesService.getCity(city_id)
    }

    getRegionsList(
        page: number,
        search?: string,
        limit?: number
    ): Promise<GetRegionsListResponseT> {
        return citiesService.getRegionsList(page, search, limit)
    }

    getZonesList(page: number, search?: string): Promise<GetZonesResponseT> {
        return citiesService.getZonesList(page, search)
    }

    getRegions(): Promise<GetRegionsResponseT> {
        return citiesService.getRegions()
    }

    getCitiesBySender(sender_id: number): Promise<GetCitiesBySenderResponseT> {
        return citiesService.getCitiesBySender(sender_id)
    }

    createCity(payload: CityPayloadT): Promise<CityResponseT> {
        return citiesService.createCity(payload)
    }

    updateCity(city_id: number, city_payload: UpdateCityPayloadT): Promise<void> {
        return citiesService.updateCity(city_id, city_payload)
    }

    deleteCity(city_id: number): Promise<void> {
        return citiesService.deleteCity(city_id)
    }

    createRegion(payload: RegionPayloadT): Promise<RegionResponseT> {
        return citiesService.createRegion(payload)
    }

    updateRegion(region_id: number, region_payload: RegionPayloadT): Promise<void> {
        return citiesService.updateRegion(region_id, region_payload)
    }

    enableAvia(id: number): Promise<void> {
        return citiesService.enableAvia(id)
    }

    disableAvia(id: number): Promise<void> {
        return citiesService.disableAvia(id)
    }

    deleteRegion(region_id: number): Promise<void> {
        return citiesService.deleteRegion(region_id)
    }
}

export const cities = new CitiesRealisation()
